import { createSelector } from 'reselect';

import { UntaxedAmount } from '@mews-distributor/common';
import { getNumberProp } from '@mews/fp';
import { DecimalService } from '@mews/framework';

import { ApplicationState } from '../../../types';
import { getCurrencyPrecision } from '../../globalization/selectors';
import { getExchangeRate } from './selectors';

interface ConvertPriceProps {
    value: number;
    sourceCurrencyCode: string;
    targetCurrencyCode: string;
    enterpriseId: string;
    currencyCode: string;
}

export const convertPrice = createSelector<ApplicationState, ConvertPriceProps, number, number, number, number>(
    getNumberProp('value'),
    getCurrencyPrecision,
    getExchangeRate,
    (value, precision, exchangeRateMultiplier) => {
        const decimalValue = DecimalService.multiply(
            DecimalService.parse(value),
            DecimalService.parse(exchangeRateMultiplier)
        );

        return DecimalService.toNumber(DecimalService.round(decimalValue, precision));
    }
);

interface ConvertAmountOptions {
    amount: UntaxedAmount;
    targetCurrencyCode: string;
    enterpriseId: string;
}

export const convertAmount = (
    state: ApplicationState,
    { amount: { netValue, grossValue, currency }, targetCurrencyCode, enterpriseId }: ConvertAmountOptions
): UntaxedAmount => ({
    currency: targetCurrencyCode,
    netValue: convertPrice(state, {
        enterpriseId,
        currencyCode: currency,
        sourceCurrencyCode: currency,
        targetCurrencyCode,
        value: netValue,
    }),
    grossValue: convertPrice(state, {
        enterpriseId,
        currencyCode: currency,
        sourceCurrencyCode: currency,
        targetCurrencyCode,
        value: grossValue,
    }),
});
